<template>
  <div v-if="isProcurator" class="mb-4">
    <v-alert v-if="requireClient && !clientId" dense text type="info">
      Selecione o caso para listar os credores que você pode representar.
    </v-alert>

    <v-alert v-if="!loading && !items.length && (!requireClient || clientId)" dense text type="warning">
      <template v-if="allowPending">
        Nenhum credor com procuração cadastrada foi encontrado. Cadastre a procuração na Área do Procurador.
      </template>
      <template v-else>
        Nenhum credor com associação aprovada foi encontrado. Solicite a associação na Área do Procurador.
      </template>
    </v-alert>

    <v-autocomplete
      v-model="selectedId"
      :items="items"
      :loading="loading"
      item-text="label"
      item-value="id"
      label="Credor representado"
      outlined
      dense
      clearable
      :disabled="disabled || (requireClient && !clientId)"
      :rules="required ? [$rules.required] : []"
      :no-data-text="allowPending ? 'Nenhum credor encontrado' : 'Nenhum credor aprovado encontrado'"
      @change="emitSelected">
    </v-autocomplete>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProcuratorCreditorSelector',

  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    required: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: [Number, String],
      default: null,
    },
    requireClient: {
      type: Boolean,
      default: false,
    },
    // Inclui procuracoes ainda em analise (habilitacoes e divergencias podem ser
    // apresentadas em carater provisorio). Votacao e credenciamento seguem so aprovadas.
    allowPending: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      items: [],
      selectedId: this.value,
    };
  },

  computed: {
    isProcurator() {
      return !!this.$root.user && Number(this.$root.user.type) === 2;
    },
  },

  watch: {
    value(value) {
      this.selectedId = value;
    },
    clientId() {
      this.selectedId = null;
      this.$emit('input', null);
      this.load();
    },
  },

  created() {
    if (this.isProcurator) this.load();
  },

  methods: {
    async load() {
      if (this.requireClient && !this.clientId) {
        this.items = [];
        return;
      }

      this.loading = true;

      try {
        const search = this.allowPending ? { status_in: '0,1' } : { status: 1 };
        if (this.clientId) search.client_id = this.clientId;

        const result = await axios.get('/api/procurators/creditors', {
          params: {
            // Sem limit o backend pagina em 10 e os demais credores
            // associados nao aparecem na selecao.
            page: 1,
            limit: 1000,
            search: JSON.stringify(search),
          },
        });

        const content = result.data.content;
        const data = Array.isArray(content) ? content : content.data || [];

        this.items = data
          .filter(item => item.creditor_user_id)
          .map(item => ({
            ...item,
            id: item.creditor_user_id,
            label: `${item.creditor_name || 'Credor'} - ${item.creditor_registration || 'sem CPF/CNPJ'}${Number(item.status) === 0 ? ' (procuração em análise)' : ''}`,
          }));

        // A tela pai usa a lista para o credenciamento em lote e para saber se ha
        // associacao aprovada (documentos reaproveitados).
        this.$emit('loaded', this.items);
        if (this.selectedId) this.emitSelected();
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 3000 });
      } finally {
        this.loading = false;
      }
    },

    emitSelected() {
      const selected = this.items.find(item => Number(item.id) === Number(this.selectedId)) || null;

      this.$emit('input', this.selectedId);
      this.$emit('selected', selected);
    },
  },
};
</script>
